import { createContext, useContext, useState, useEffect } from 'react'
import { facilityApi } from '../services/api'
import { useAuth } from './AuthContext'

const FacilityContext = createContext(null)

export function FacilityProvider({ children }) {
  const { user } = useAuth()
  const [facilities, setFacilities]         = useState([])
  const [activeFacility, setActiveFacility] = useState(null)
  const [loading, setLoading]               = useState(false)

  useEffect(() => {
    if (!user) { setFacilities([]); setActiveFacility(null); return }
    setLoading(true)
    facilityApi.list()
      .then(({ data }) => {
        setFacilities(data.data)
        // Restore last selected facility from localStorage
        const savedId = localStorage.getItem('active_facility_id')
        const found   = data.data.find(f => f.id === Number(savedId)) || data.data[0] || null
        setActiveFacility(found)
      })
      .catch(console.error)
      .finally(() => setLoading(false))
  }, [user])

  const switchFacility = (facility) => {
    setActiveFacility(facility)
    localStorage.setItem('active_facility_id', facility.id)
  }

  const refreshFacilities = () => {
    return facilityApi.list().then(({ data }) => {
      setFacilities(data.data)
      // Keep active facility in sync
      if (activeFacility) {
        const updated = data.data.find(f => f.id === activeFacility.id)
        if (updated) setActiveFacility(updated)
      }
      return data.data
    })
  }

  return (
    <FacilityContext.Provider value={{
      facilities,
      activeFacility,
      switchFacility,
      refreshFacilities,
      loading,
    }}>
      {children}
    </FacilityContext.Provider>
  )
}

export const useFacility = () => {
  const ctx = useContext(FacilityContext)
  if (!ctx) throw new Error('useFacility must be used within FacilityProvider')
  return ctx
}
